<template>
  <div style="text-align: center">
    <img
      style="max-width: 100%; margin: 10% auto 0; padding: 20px"
      src="../../assets/404.png"
    />
    <h4 style="font-size: 40px; color: #333; margin-top: 75px">
      啊呀，不小心飞出地球了！
    </h4>
    <p style="font-size: 14px; color: #777; margin: 0 0 25px 0">
      此页面已无法找到，可能已经被删除或地址错误
    </p>
    <el-button type="danger" round @click="routerGo('/')">返回首页</el-button>
  </div>
</template>

<script>
export default {
  methods: {
    routerGo(path) {
      this.$router.push(path);
    },
  },
};
</script>

<style></style>
